import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import './CollectionCreator.css';
import { togglePopup } from '../../../slices/collectionSlice';
import { createCollection, getCollections } from '../../../services/collections.service';

const workspaceID = '272c97f6-8215-4071-8dab-f26b4ae2b9f6';

const CollectionPopup = ( props ) => {
    const [collectionName, setCollectionName] = useState("");
    const dispatch = useDispatch();

    const createCollectionSuccess = () => {
        props.setLoadingCollections(true);
        dispatch(getCollections(props.successCallback));
    };

    const handleSave = () => {
        if (collectionName.trim()) {
            const params = {
                name: collectionName,
                workspaceID,
                description: 'new collection',
            }
            dispatch(createCollection(params, createCollectionSuccess));
            setCollectionName("");
            dispatch(togglePopup());
        }
    };

    return (
        <div className="collection-popup-overlay">
            <div className="Create-collection">
                <div className='Collections-popup-title-box'>
                    <span className="Collections-popup-title">New Collection</span>
                </div>
                <div className='Collections-popup-input-box'>
                    <span className="Collections-popup-input-title">Name</span>
                    <input
                        type="text"
                        placeholder="Enter collection name"
                        className='Collections-popup-input'
                        value={collectionName}
                        onChange={(e) => setCollectionName(e.target.value)}
                    />
                </div>
                <div className="collections-popup-buttons">
                    <button onClick={() => dispatch(togglePopup(false))} className="collections-cancle-btn">Cancel</button>
                    <button onClick={handleSave} className="collections-create-btn">Create</button>
                </div>
            </div>
        </div>
    );
};

export default CollectionPopup;
